import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { ToasterService } from '../../_services/toaster.service';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenicationService} from '../../_services/authenication.service';
import { PricesService } from '../../_services/prices.service';

import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-add-promocode',
  templateUrl: './add-promocode.component.html',
  styleUrls: ['./add-promocode.component.css']
})
export class AddPromocodeComponent implements OnInit {
  addPromoCodeForm: FormGroup;
  submitted = false;
  returnUrl: string;
  userdetaild: string;
  // tslint:disable-next-line:variable-name
  doctor_price: any;
  // tslint:disable-next-line:variable-name
  commission_price: any;
  // tslint:disable-next-line:variable-name
  more_value: 0;


  // tslint:disable-next-line:max-line-length
  constructor(private formBuilder: FormBuilder, private router: Router, private route: ActivatedRoute, private toaster: ToasterService, private authenicationService: AuthenicationService, private pricesService: PricesService, private spinnerService: Ng4LoadingSpinnerService) { }

  ngOnInit() {
    this.userdetaild = this.authenicationService.userDetails();
    if (!this.userdetaild) {
      this.router.navigate(['/login']);
    }

    if (!this.userdetaild || this.userdetaild['users_usertype'] !== 'admin') {
      this.authenicationService.logout();
      this.router.navigateByUrl('/login');
    }

    // tslint:disable-next-line:triple-equals
    if (!this.userdetaild || this.userdetaild['users_usertype'] == 'employee2') {
      this.router.navigate(['/']);
    }


    this.addPromoCodeForm = this.formBuilder.group({
      type: ['', [Validators.required]],
      promocode: ['', [Validators.required]],
      discount_type: ['', [Validators.required]],
      discount_value: ['', [Validators.required, Validators.min(0)]],
      for_gift: ['false', [Validators.required]],
      more_than_one: ['', [Validators.required]],
      more_than_value: ['', [Validators.required, Validators.min(0)]],
      description: ['', [Validators.required]],
      max_number: ['', [Validators.required, Validators.min(0)]],
      max_person_or_next_session: ['', [Validators.required, Validators.min(0)]],
      total_session: ['', [Validators.required, Validators.min(0)]],
      max_discount: ['', [Validators.required, Validators.min(0)]],
      status: ['true', [Validators.required]],
    });



    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';

  }

  get f() { return this.addPromoCodeForm.controls; }

  onSubmit() {
    this.submitted = true;
    this.spinnerService.show();
    // stop here if form is invalid
    if (this.addPromoCodeForm.invalid) {
      this.spinnerService.hide();
      return;
    }

    const addPayload = {
      type: this.addPromoCodeForm.controls.type.value,
      promocode: this.addPromoCodeForm.controls.promocode.value.toUpperCase(),
      discount_type: this.addPromoCodeForm.controls.discount_type.value,
      more_than_one: (this.addPromoCodeForm.controls.more_than_one.value) ? this.addPromoCodeForm.controls.more_than_one.value : 'false',
      for_gift: (this.addPromoCodeForm.controls.for_gift.value) ? this.addPromoCodeForm.controls.for_gift.value : 'false',
      more_than_value: (this.addPromoCodeForm.controls.more_than_value.value) ? this.addPromoCodeForm.controls.more_than_value.value : '0',
      description: this.addPromoCodeForm.controls.description.value,
      max_number: this.addPromoCodeForm.controls.max_number.value,
      max_person_or_next_session: this.addPromoCodeForm.controls.max_person_or_next_session.value,
      total_session: this.addPromoCodeForm.controls.total_session.value,
      discount_value: this.addPromoCodeForm.controls.discount_value.value,
      max_discount: this.addPromoCodeForm.controls.max_discount.value,
    };


    this.addPromoCode(addPayload);

  }




  addPromoCode(payload) {
    this.pricesService.addPromoCode(payload)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            this.spinnerService.hide();
            this.router.navigate(['/get-promocodes']);
          } else {
            this.spinnerService.hide();
            this.toaster.showError('Add PromoCode', data.ResponseMessage);
          }
        },
        error => {
          this.spinnerService.hide();
          this.toaster.showError('Add PromoCode', error);
        });
  }

}
